import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  title: {
    marginBottom: '1.5rem',
  },
  advancedSettingsContainer: {
    marginTop: '2rem',
    padding: '0 1rem',
  },
}))

export default useStyles
